import { subAdminService } from '../../../services';

export const config: any = {
  addSubAdminAccount: (params: any) =>
    subAdminService.addSubAdminAccount(params),
  listAllFeatures: () => subAdminService.listAllFeatures(),
};
